import styled, { css } from 'styled-components'
import { WizardProps } from '.'
import theme from 'presentation/styles/theme'

export type WrapperProps = Pick<
  WizardProps,
  'activeColor' | 'completedColor' | 'activeBackgroundColor'
>

export type StepIconRootProps = {
  activeColor: keyof typeof theme.ds.colors
  completedColor: keyof typeof theme.ds.colors
}

export const StepIconRoot = styled.div<StepIconRootProps>`
  ${({ theme, activeColor, completedColor }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${theme.ds.colors.neutral300};
    color: ${theme.ds.colors.white};

    &.completed:not(.active) {
      background-color: ${theme.ds.colors[completedColor]};
    }

    &.active {
      background-color: ${theme.ds.colors[activeColor]};

      @media (max-width: 959px) {
        box-shadow: 0 0 0 2px ${theme.ds.colors.white},
          0 0 0 4px ${theme.ds.colors[activeColor]};
      }
    }
  `}
`

export const StepIconText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.ds.typography.size.xxsmall};
    font-weight: ${theme.ds.typography.weight.semiBold};
    line-height: 1;
  `}
`

export const Wrapper = styled.div<WrapperProps>`
  ${({ activeColor, completedColor, activeBackgroundColor, theme }) => css`
    width: 100%;

    .MuiStepper-root {
      padding: 0;
    }

    .MuiStep-root:has(.MuiStepLabel-active) {
      border-radius: ${theme.ds.typography.border.radius.large};
      transition: background-color 0.3s ease;
      background-color: ${theme.ds.colors[activeBackgroundColor!]};
      padding-left: 0;
    }

    .MuiStepIcon-root.MuiStepIcon-active {
      color: ${theme.ds.colors[activeColor!]};
    }

    .MuiStepIcon-root.MuiStepIcon-completed:not(.MuiStepIcon-active) {
      color: ${theme.ds.colors[completedColor!]};
    }

    .MuiStepIcon-text {
      font-weight: ${theme.ds.typography.weight.semiBold};
    }

    .MuiStepIcon-root.MuiStepIcon-active .MuiStepIcon-text {
      font-weight: ${theme.ds.typography.weight.black};
    }

    .MuiStepLabel-label {
      font-family: ${theme.ds.typography.fontFamily};
      font-weight: ${theme.ds.typography.weight.semiBold};
      color: ${theme.ds.colors.textDisabled};
    }

    .MuiStepLabel-label.MuiStepLabel-active {
      color: ${theme.ds.colors[activeColor!]};
    }

    .MuiStepLabel-label.MuiStepLabel-completed:not(.MuiStepLabel-active) {
      color: ${theme.ds.colors.textPrimary};
    }
  `}
`
